import { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import {
  TeachersActionLabels,
  TeachersColumns,
  ITeacher,
  orderBySet,
  orderSet,
  selectOrder,
  selectOrderBy,
} from "features/Teachers";
import { useAppDispatch, useAppSelector } from "app/hooks";
import TableBody from "./TableBody";
import DataNotFound from "components/DataNotFound";
import { DeskIcon } from "components/SVGs";
import { useTranslation } from "react-i18next";
import TableSkeleton from "../../common/Skeletons/Table";
import TableHead from "../../common/TableHead";
import { FireBaseContext } from "contexts/FireBase";

interface ITeacherTable {
  allList: ITeacher[];
  pageList: ITeacher[];
  filteredList: ITeacher[];
}
export default function TeachersTable({
  pageList,
  allList,
  filteredList,
}: ITeacherTable) {
  const { logEvent } = useContext(FireBaseContext);
  const [isCompMounted, setCompMounted] = useState(false);
  useEffect(() => {
    const handle = setTimeout(() => setCompMounted(true), 200);
    return () => {
      setCompMounted(false);
      clearTimeout(handle);
    };
  }, []);
  const { t } = useTranslation();
  const columns = Object.keys(TeachersColumns) as TeachersColumns[];
  const dispatch = useAppDispatch();
  const order = useAppSelector((state) => selectOrder(state));
  const orderBy = useAppSelector((state) => selectOrderBy(state));
  const handleRequestSort = (
    event: React.MouseEvent<unknown, MouseEvent>,
    property: TeachersColumns
  ) => {
    const isAsc = orderBy === property && order === "asc";
    dispatch(orderSet(isAsc ? "desc" : "asc"));
    dispatch(orderBySet(property));
    const sortType = {
      Teacher: "By Name",
      Email: "By Email",
      ClassesNo: "By Classes Number",
      StudentsNo: "By Students Number",
    };
    logEvent("ClickOnSortTeacher", {
      Sort_Type: sortType[property],
    });
  };

  const classesCounter = filteredList.reduce((count, item) => {
    count += item.classesno;
    return count;
  }, 0);
  const studentsCounter = filteredList.reduce((count, item) => {
    count += item.studentsno;
    return count;
  }, 0);
  return !pageList.length && isCompMounted ? (
    <DataNotFound
      text={allList?.length ? t("No data") : t("No teachers exists")}
      icon={<DeskIcon sx={{ fontSize: "120px" }} />}
    />
  ) : isCompMounted ? (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="Teachers List">
        <TableHead<TeachersColumns>
          data={columns}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          actionLabels={Object.keys(TeachersActionLabels) as string[]}
          counters={{
            Teacher: filteredList.length,
            ClassesNo: classesCounter,
            StudentsNo: studentsCounter,
          }}
        />
        <TableBody list={pageList} />
      </Table>
    </TableContainer>
  ) : (
    <TableSkeleton />
  );
}
